import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(Element, {
  dialog: {
    lockScroll: false  // 禁用锁定滚动条
  }
});
Vue.use( Element, { locale } )
